import React, {useState, useEffect} from 'react';
import * as Icons from 'react-feather';
import {useList} from 'store/list'
import {useCore} from 'store/core'
import Loading from 'components/Loading'
import ListSearch from 'components/list/ListSearch'
import ListPagination from 'components/list/ListPagination'
import Add from './Add'
import Edit from './Edit'
import Delete from "./Delete";
import {handleSuccessMessages} from "../../../../store/auth";

export default function BlockUsers() {
   const path = {
      baseRoute: '/panel/account-statuses',
      aliasName: 'کاربران مسدود',
      type: 'BlockUsers',
   };
   const {dispatch, clear, getList, list, load, create, update, remove, listSearch, from, to, total} = useList();
   const {getRoles} = useCore();
   const [showAdd, setShowAdd] = useState(false);
   const [showEdit, setShowEdit] = useState(false);
   const [showDelete, setShowDelete] = useState(false);
   const [item, setItem] = useState(false);

   useEffect(() => {
      dispatch(getList(path));
      dispatch(getRoles());
      return () => {
         dispatch(clear())
      }
   }, []);

   return (
      <>
         <Add title="افزودن" show={showAdd} close={() => {
            setShowAdd(false)
         }} submit={(values) => {
            dispatch(create(path, values, () => {
               dispatch(getList(path))
               handleSuccessMessages("کاربر مورد به لیست سیاه اضافه شد")
            }))
         }}/>
         <Edit item={item} title="ویرایش" show={showEdit} close={() => {
            setShowEdit(false)
         }} submit={(values, id) => {
            dispatch(update(path, id, values, () => {
               dispatch(getList(path))
               handleSuccessMessages("عملیات با موفقیت انجام شد")
            }))
         }}/>

         <Delete title="حذف" show={showDelete} close={() => {
            setShowDelete(false);
         }} submite={() => {
            dispatch(remove(path, list, item.id, () => {
               dispatch(getList(path))
               handleSuccessMessages("عملیات با موفقیت انجام شد")
               setShowDelete(false);
            }))
         }}/>

         <div className="content" style={{marginBottom: 80}}>

            <h2 className="intro-y text-lg font-medium mt-10">
               کاربران مسدود یا غیر فعال
            </h2>
            <div className="grid grid-cols-12 gap-6 mt-5">
               <div className="intro-y col-span-12 flex flex-wrap sm:flex-nowrap items-center mt-2">
                  <button onClick={() => {
                     setShowAdd(true)
                  }} className="btn btn-primary shadow-md mr-2">افزودن
                  </button>
                  {load &&
                  <div className="hidden md:block mx-auto text-gray-600">در حال بارگذاری</div>}
                  {!load &&
                  <div className="hidden md:block mx-auto text-gray-600">
                     {from && `نمایش ${from} تا ${to} از ${total}`}
                  </div>}
                  <ListSearch search={(key) => {
                     dispatch(listSearch(path, key))
                  }}/>
               </div>

               <div className="intro-y col-span-12 overflow-auto lg:overflow-visible">
                  <table className="table table-report -mt-2">
                     <thead>
                     <tr>
                        <th className="whitespace-nowrap text-center">نام کاربری</th>
                        <th className="whitespace-nowrap text-center">نام و نام خانوادگی</th>
                        <th className="whitespace-nowrap text-center">وضعیت</th>
                        <th className="whitespace-nowrap text-center">توضیحات</th>
                        <th className="whitespace-nowrap text-center">عملیات</th>
                     </tr>
                     </thead>
                     {load && <Loading/>}
                     {list && !list.length > 0 && <h3 className="flex justify-center">چیزی یافت نشد</h3>}
                     <tbody>
                     {!load && list && list.length > 0 && list.map((item) => (
                        <tr className="intro-x">
                           <td>
                              <p className="font-medium whitespace-nowrap text-center">{item.user_name}</p>
                           </td>
                           <td>
                              <p className="font-medium whitespace-nowrap text-center">
                                 {item.user && item.user.first_name || item.user && item.user.last_name ? item.user.first_name + ' ' + item.user.last_name : "کاربر ناشناس"}
                              </p>
                           </td>
                           <td className="text-center">
                              {item.status}
                           </td>
                           <td className="text-center">
                              {item.reason}
                           </td>
                           <td className="table-report__action w-56">
                              <div className="flex justify-center items-center">
                                 <a className="flex items-center ml-3 cursor-pointer" onClick={() => {
                                    setItem(item);
                                    setShowEdit(true)
                                 }}> <Icons.CheckSquare className="w-4 h-4 ml-1"/> ویرایش </a>
                                 <a className="flex items-center text-theme-6 cursor-pointer"
                                    onClick={() => {
                                       setItem(item);
                                       setShowDelete(true);
                                    }}>
                                    <Icons.Trash2 className="w-4 h-4 ml-1 "/>حذف </a>
                              </div>
                           </td>
                        </tr>))}
                     </tbody>
                  </table>
               </div>
               <ListPagination getList={(page, perPage) => {
                  dispatch(getList(path, page, perPage))
               }}/>
            </div>
         </div>
      </>
   );
}
